<template>
  <el-menu :default-active="defaultActive" class="task-menu" @select="selectHandler">
    <template v-for="item in menus">
      <el-menu-item
        v-if="!Array.isArray(item.children) || !item.children.length"
        :key="item[field.index]"
        :index="item[field.index]"
      >
        {{ item[field.label] }}
      </el-menu-item>
      <el-submenu v-else :index="item[field.index]" :key="item[field.index]">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">{{ item[field.label] }}</span>
        </template>
        <template v-if="Array.isArray(item[field.children])">
          <el-submenu
            v-for="subItem in item[field.children]"
            :index="subItem[field.index]"
            :key="subItem[field.index]"
          >
            <span slot="title">{{ subItem[field.label] }}</span>
            <template v-if="Array.isArray(subItem[field[field.children]])">
              <el-menu-item
                v-for="subItem in subItem[field.children]"
                :key="subItem[field.index]"
                :index="subItem[field.index]"
              >
                {{ subItem[field.label] }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { getTask } from '@/api/task';

export default {
  data() {
    return {
      field: {
        index: 'id',
        label: 'name',
        children: 'children'
      },
      defaultActive: '',
      active: '',
      menus: []
    };
  },
  methods: {
    selectHandler(taskId) {
      this.$emit('select', taskId);
    }
  },
  mounted() {
    getTask().then(res => {
      this.menus.splice(0, Infinity, ...res.data);
    });
  }
};
</script>

<style lang="scss">
.el-menu.task-menu:not(.el-menu--collapse) {
  min-height: 400px;
  max-height: calc(100% - 40px);
}
</style>
